import { Link, LinkProps } from 'react-router-dom';
import { Skeleton } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineDropdown from 'components/_core/SunshineDropdown';

interface BaseAttachmentCardProps {
  linkTo: LinkProps['to'];
  isDeleting: boolean;
  title: string;
  deleteLabel: string;
  onDelete: () => void;
}

const BaseAttachmentCard: FCWithChildren<BaseAttachmentCardProps> = ({
  children,
  deleteLabel,
  isDeleting,
  linkTo,
  onDelete,
  title,
}) => {
  return (
    <SunshineCard alignItems="center" as={Link} isBoxed={false} to={linkTo}>
      <SunshineCard.Slot name="aside">{children}</SunshineCard.Slot>

      {isDeleting ? (
        <Skeleton
          borderRadius="radius-10"
          endColor="grey.300"
          height="40px"
          startColor="grey.100"
          width="100%"
        />
      ) : (
        // Using an array because if we use a fragment "React childs" become 1
        // and we end up not rendering the SunshineCard.Slot
        [
          <SunshineCard.Content key="content">
            <SunshineCard.Title>{title}</SunshineCard.Title>
          </SunshineCard.Content>,

          <SunshineCard.Slot key="action" name="action">
            <SunshineDropdown>
              <SunshineDropdown.Trigger>
                <SunshineCard.SunshineIcon
                  marginRight="space-8"
                  name="vertical-ellipsis"
                />
              </SunshineDropdown.Trigger>

              <SunshineDropdown.List>
                <SunshineDropdown.Item
                  colorScheme="red"
                  icon="trash"
                  onClick={(event) => {
                    event.preventDefault();
                    onDelete();
                  }}
                >
                  {deleteLabel}
                </SunshineDropdown.Item>
              </SunshineDropdown.List>
            </SunshineDropdown>
          </SunshineCard.Slot>,
        ]
      )}
    </SunshineCard>
  );
};

export default BaseAttachmentCard;
